var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPurchaseLinkIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 12,
    viewBox: "0 0 14 12",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.64287 0.599609C0.952331 0.599609 0.399902 1.15204 0.399902 1.84258C0.399902 2.53311 0.952331 3.08554 1.64287 3.08554C2.3334 3.08554 2.88583 2.53311 2.88583 1.84258C2.88583 1.15204 2.31959 0.599609 1.64287 0.599609Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.24737 2.8922H12.4704C13.0504 2.8922 13.52 2.42263 13.52 1.84258C13.52 1.26253 13.0504 0.792969 12.4704 0.792969H5.24737C4.66732 0.792969 4.19775 1.26253 4.19775 1.84258C4.21156 2.42263 4.68113 2.8922 5.24737 2.8922Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.64287 4.75684C0.952331 4.75684 0.399902 5.30927 0.399902 5.9998C0.399902 6.69034 0.952331 7.24277 1.64287 7.24277C2.3334 7.24277 2.88583 6.69034 2.88583 5.9998C2.88583 5.30927 2.31959 4.75684 1.64287 4.75684Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4704 4.9502H5.24737C4.66732 4.9502 4.19775 5.41976 4.19775 5.99981C4.19775 6.57986 4.66732 7.04943 5.24737 7.04943H12.4704C13.0504 7.04943 13.52 6.57986 13.52 5.99981C13.52 5.41976 13.0504 4.9502 12.4704 4.9502Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1.64287 11.4C2.32934 11.4 2.88583 10.8435 2.88583 10.157C2.88583 9.47056 2.32934 8.91406 1.64287 8.91406C0.956397 8.91406 0.399902 9.47056 0.399902 10.157C0.399902 10.8435 0.956397 11.4 1.64287 11.4Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4704 9.10742H5.24737C4.66732 9.10742 4.19775 9.57699 4.19775 10.157C4.19775 10.7371 4.66732 11.2067 5.24737 11.2067H12.4704C13.0504 11.2067 13.52 10.7371 13.52 10.157C13.52 9.57699 13.0504 9.10742 12.4704 9.10742Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPurchaseLinkIcon);
export default __webpack_public_path__ + "static/media/purchase-link-icon.9477781f26a3b8736bddacde7debbd53.svg";
export { ForwardRef as ReactComponent };